import { useEffect, useState } from "react";
import api from "../../../../../features/auth/axiosConfig";
import { Branch } from "../types/branch";

export const useBranchData = (id: string, updateFormData: (data: Partial<any>) => void) => {
  const [branchData, setBranchData] = useState<Branch>();

  useEffect(() => {
    api.get(`/app/v1/pos/branch/${id}`).then((res) => {
      const branch: Branch = res.data.result;
      setBranchData(branch);

      updateFormData({
        Branchname: branch.Branch_name,
        branchopeningdate: branch.Branch_Opening_date,
        address1: branch.Address.address1,
        street: branch.Address.street,
        Pincode: branch.Address.Pincode,
        selectedCountry: branch.Address.selectedCountry,
        selectedState: branch.Address.selectedState,
        selectedCity: branch.Address.selectedCity,
        inputValue: branch.Branch_Opening_date,
      });
    });
  }, [id]);

  return branchData;
};
